import { render, staticRenderFns } from "./FilterByRegistrationNumber.vue?vue&type=template&id=8a67b954&scoped=true"
import script from "./FilterByRegistrationNumber.vue?vue&type=script&lang=js"
export * from "./FilterByRegistrationNumber.vue?vue&type=script&lang=js"
import style0 from "./FilterByRegistrationNumber.vue?vue&type=style&index=0&id=8a67b954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67b954",
  null
  
)

export default component.exports